import { TextStyle } from "./text-style";

export class ChartLegend {
alinment?: string; // start, center, or end
position?: string; // top, bottom, left, right, none, labeled
lines?: number;
textStyle?: TextStyle = new TextStyle();
}
